<template>
  <div class="main-content" id="panel">
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-2 col-6">
              <h2>Set Capital</h2>
            </div>
            <div class="col-lg-10 col-md-12 col-10 text-right bid">
              <div class="input-group d-inline-flex justify-content-end">
              <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                <i @click="searchTrader()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                <input v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                </form>
                <div class="abs-btn-grp-arbs d-flex" v-if="isBranchRiskManager || isSuperAdmin">
                    <div>
                        <span class="input-group-text">BRANCH LIMIT ALERT</span>
                    </div>
                    <!-- <input v-model="branchLimit" class="form-control" type="number"> -->
                    <currency-input
                                    v-model="branchLimit"
                                    currency="USD"
                                    :distraction-free="{'hideNegligibleDecimalDigits' : 'true'}"
                                    class="form-control"
                                />
                    <button :disabled="!branchLimit" @click="saveBranchLimit()" type="button" class="btn btn-success rounded arbs-btn">
                        <i class="fas fa-save"></i>
                        Save
                    </button>
                </div>
                <div v-if="isBranchRiskManager || isSuperAdmin">
                  <button v-if="branchData && branchData.tradeKillActive"  @click="killOperations('ENABLE')" type="button" class="btn btn-success mr-3"><i class="fa fa-toggle-on"></i> ENABLE TRADING</button>
                  <button v-if="branchData && !branchData.tradeKillActive"  @click="killOperations('DISABLE')" type="button" class="btn btn-danger mr-3"><i class="fa fa-power-off"></i> DISABLE TRADING</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
    <div class="container-fluid mt--6 ">
      <div class="row">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader">
                <img src="@/assets/img/loader.svg" alt="" />
              </div>
              <table
                class="table align-items-center table-flush table-hover bidtbl"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th
                      scope="col"
                      class="sort"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'firstName'
                          ? 'sort-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'firstName'
                          ? 'sort-desc'
                          : '',
                      ]"
                      @click="sort('firstName')"
                    >
                      Trader
                    </th>
                    <th scope="col" class="text-center">Cusip Max Qty</th>
                    <th
                      scope="col"
                      class="sort"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'autobidderCapital'
                          ? 'sort-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'autobidderCapital'
                          ? 'sort-desc'
                          : '',
                      ]"
                      @click="sort('autobidderCapital')"
                    >
                    Capital Invested/Bought Today <br>IMS CAPITAL/AT RISK
                    </th>
                    <!-- <th scope="col" class="text-left">CUSIP CONC/DOLLAR AMOUNT/Bought Today/AT RISK</th> -->
                    <th scope="col" class="text-left">STATE/CONC/DOLLAR AMOUNT<br>Bought Today/IMS CAPITAL/AT RISK </th>
                    <th scope="col" class="text-left">RATING/CONC/DOLLAR AMOUNT <br> Bought Today/IMS CAPITAL/AT RISK </th>
                    <th scope="col" class="text-center">COMPLIANCE <br> STATUS</th>
                    <th scope="col" class="text-center">TRADING <br> STATUS</th>
                    <th scope="col" class="text-center" v-if="isBranchRiskManager">Action</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="trader in traders" :key="trader.id">
                    <td
                    >
                      {{ trader.firstName }} {{ trader.lastName }}
                    </td>
                    <td class="text-center" >
                     <span  v-if="trader.cusipConcList.length > 0">
                      {{ formatNumber(trader.cusipConcList[0].concentrationValue) }} 
                    </span> 
                    </td>
                    <td class="input-d text-left">
                      <span class="text-warning" v-if="trader.maxCapitalConcList.length > 0">
                      {{ trader.maxCapitalConcList[0].concentrationValueDolAmt  | currency }} / {{trader.maxCapitalConcList[0].capitalInvestedDolAmt  | currency}}  <br> {{ trader.maxCapitalConcList[0].invOfferDolAmt  | currency}} / {{trader.maxCapitalConcList[0].capitalAtRisk  | currency }}
                    </span> 
                    </td>
                    
                    <td class="text-left" >
                      <div class="listAcc" v-for="(state,index) in trader.stateConcList" :key="index" v-show="index < 3">
                        <span class="text-primary border-bottom py-2">
                          {{ state.concentration }} / {{ state.concentrationValue }}% / {{ state.concentrationValueDolAmt  | currency }} <br>
                         {{ state.capitalInvestedDolAmt  | currency }} /  {{ state.invOfferDolAmt  | currency}} /  {{ state.capitalAtRisk  | currency}}
                        </span>
                      </div>
                      <span  @click="toggleViewConcentrationModal(trader,'STATE')" class="dropdown-item moreAcc" v-show="trader.stateConcList.length > 3">
                          ({{trader.stateConcList.length - 3 }} More)
                      </span>
                    </td>
                    <td class="text-left" >
                      <div class="listAcc" v-for="(rating,index) in trader.creditRatingConcList" :key="index" v-show="index < 3">
                        <span class="text-success border-bottom py-2">{{ rating.concentrationList[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ rating.concentrationList[rating.concentrationList.length - 1] }} / {{ rating.concentrationValue }}% / {{ rating.concentrationValueDolAmt  | currency }} <br> {{ rating.capitalInvestedDolAmt  | currency }} /  {{ rating.invOfferDolAmt  | currency}} /  {{ rating.capitalAtRisk  | currency}}</span>
                      </div>
                      <span  @click="toggleViewConcentrationModal(trader,'RATING')" class="dropdown-item moreAcc" v-show="trader.creditRatingConcList.length > 3">
                          ({{trader.creditRatingConcList.length - 3 }} More)
                      </span>
                    </td>
                    <td class="text-center">
                       <span v-if="trader.complianceCheck == 'TRUE'" class="text-success">ENABLED</span>
                       <span v-if="trader.complianceCheck == 'FALSE'" class="text-danger">DISABLED</span>
                    </td>
                    <td class="text-center">
                       <span v-if="trader.autobidderActive == 'TRUE'" class="text-success">ENABLED</span>
                       <span v-if="trader.autobidderActive == 'FALSE'" class="text-danger">DISABLED</span>
                    </td>
                    <td class="text-center"   v-if="isBranchRiskManager" >
                      <div style="display: grid;">
                        <button
                          type="button"
                          @click="toggleConcentrationModal(trader)"
                          class="btn btn-secondary  btn-sm my-1 autowidth"
                        >
                          <i class="fas fa-check"></i> SET CONCENTRATION
                        </button>
                        <button
                          v-if="trader.autobidderActive == 'FALSE'"
                          data-toggle="tooltip" data-placement="left"  data-original-title="Enable trader"
                          type="button"
                          @click="enableOrdisableTrader(trader,'ENABLE')"
                          class="btn btn-success  btn-sm my-1 autowidth"
                        >
                          <i class="fa fa-toggle-on"></i> ENABLE TRADING
                        </button>
                        <button
                        v-if="trader.autobidderActive == 'TRUE'"
                          data-toggle="tooltip" data-placement="left"  data-original-title="Disable trader and cancel all bids"
                          type="button"
                          @click="enableOrdisableTrader(trader,'DISABLE')"
                          class="btn btn-danger  btn-sm my-1 autowidth"
                        >
                          <i class="fa fa-toggle-off"></i> DISABLE TRADING
                        </button>
                        <button
                          v-if="trader.complianceCheck == 'FALSE'"
                          data-toggle="tooltip" data-placement="left"  data-original-title="Enable concentration"
                          type="button"
                          @click="enableOrdisableCompliance(trader,'ENABLE')"
                          class="btn btn-secondary  btn-sm my-1 autowidth"
                        >
                          <i class="fa fa-toggle-on"></i> ENABLE COMPLIANCE
                        </button>
                        <button
                        v-if="trader.complianceCheck == 'TRUE'"
                          data-toggle="tooltip" data-placement="left"  data-original-title="Disable concentration"
                          type="button"
                          @click="enableOrdisableCompliance(trader,'DISABLE')"
                          class="btn btn-secondary  btn-sm my-1 autowidth"
                        >
                          <i class="fa fa-toggle-off"></i> DISABLE COMPLIANCE
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getTraderList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{ totalRows }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
   <Concentration 
      v-if="concentrationModalOpen"
      v-bind:traderData="selectedTrader"
      v-bind:branchData="branchData"
      v-bind:selectedOrgToken="selectedOrgToken"
      @close="toggleConcentrationModal()"/>
    <ViewConcentration
      v-if="viewConcentrationModalOpen"
      v-bind:traderData="selectedTrader"
      v-bind:type="selectedConcentrationType"
      @close="toggleViewConcentrationModal()"
      
    />  
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Concentration from "./BranchSetConcentrationModal"
import ViewConcentration from "../ConcentrationViewDataModal.vue"
export default {
  name: "traders",
  components: {
    Concentration,
    ViewConcentration
  },
  data() {
    return {
      traders: [],
      config: config,
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchValue: "",
      totalRows: 0,
      sortColumn: "firstName",
      sortOrder: "ASC",
      tenantName: null,
      selectedTrader: null,
      traderData: {},
      selectedOrgToken : null,
      isBranchRiskManager : false,
      concentrationModalOpen : false,
      branchData : null,
      isSuperAdmin : false,
      branchLimit : 0,
      viewConcentrationModalOpen : false,
      selectedConcentrationType : ""
    };
  },
  created() {},
  methods: {
    toggleViewConcentrationModal(data,type){
      this.selectedTrader = {...data}
      this.selectedConcentrationType = type
      this.viewConcentrationModalOpen = !this.viewConcentrationModalOpen;
    },
    toggleConcentrationModal(data){
      this.selectedTrader = {...data}
      this.concentrationModalOpen = !this.concentrationModalOpen;
      if(!this.concentrationModalOpen){
        this.getTraderList()
      }
    },
    saveBranchLimit(){
      let dataToSend = 
              {
                  "concentrationType": "BRANCH_EXCEPTION_LIMIT",
                  "concentration": null,
                  "concentrationValue": this.branchLimit
              }
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/add-compliance-branch-limit",dataToSend,
                auth
            )
            .then(() => {
                this.loading = false;
                this.$alert("Saved Successfully","","success")
                this.getTraderList()
            })
            .catch(e => {
                console.log(e);
            });

    },
    enableOrdisableTrader(trader,status){
        if(this.branchData && this.branchData.tradeKillActive){
          this.$alert("Disabled all traders","","error");
          return false
        }
        const message = `Are you sure you want to ${status.toLowerCase()} this trader?`;
        this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let dataToSend = [
                            {
                                "setting": "AUTOBIDDER_ACTIVE",
                                "dataType": "BOOLEAN",
                                "value": status == 'ENABLE' ?  "TRUE" : "FALSE",
                                "cognitoSub" : trader.cognitoSub
                            }
                        ]
        this.loading = true;
        const auth = {
            headers: {'org-token' : this.selectedOrgToken }
        };
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/setting",dataToSend,
                auth
            )
            .then(() => {
                this.loading = false;
                this.$alert("Successfully updated ","","success")
                this.getTraderList()
            })
            .catch(e => {
                console.log(e);
            });
        })
    },
    enableOrdisableCompliance(trader,status){
        const message = `Are you sure you want to ${status.toLowerCase()} concentration for this trader?`;
        this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let dataToSend = [
                            {
                                "setting": "COMPLIANCE_CHECK",
                                "dataType": "BOOLEAN",
                                "value": status == 'ENABLE' ?  "TRUE" : "FALSE",
                                "cognitoSub" : trader.cognitoSub
                            }
                        ]
        this.loading = true;
        const auth = {
            headers: {'org-token' : this.selectedOrgToken }
        };
        this.$http
            .post(
            config.baseUrlAutoBidder +
                "/autobidder/setting",dataToSend,
                auth
            )
            .then(() => {
                this.loading = false;
                this.$alert("Successfully updated ","","success")
                this.getTraderList()
            })
            .catch(e => {
                console.log(e);
            });
        })
    },
    killOperations(status){
        var message = "Are you sure you want to "+(status.toLowerCase())+" all traders?";
        this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
             const auth = {
                
            };
            this.loading = true;
            let isKill = status == 'ENABLE' ?  false : true;
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/kill-switch?orgToken="+authService.getOrgToken()+"&isKill="+isKill,{},
                    auth
                )
                .then(() => {
                    this.loading = false;
                    this.$alert("Under process.","","success");
                    this.getBranchData();
                    this.getTraderList();
                })
        })
    },
    searchTrader() {
      this.getTraderList();
    },
    clearSearch() {
      this.searchValue = "";
      this.getTraderList();
    },
    sort(column) {
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getTraderList();
    },
    getTraderList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {
          "org-token": this.selectedOrgToken,
        },
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/traders?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE" +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&group=Trader"+
            "&startOfDay="+
            this.moment(this.moment().format("MM-DD-YYYY")).utc().format("YYYY-MM-DD HH:mm:ss"),
          auth
        )
        .then((result) => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.traders = result.data.content;
          this.branchLimit = result.data.branchLimit ? result.data.branchLimit : 0;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getBranchData(){
      this.$http
        .get(config.baseUrlAutoBidder + "/compliance/list-branches?branchOrgToken="+authService.getOrgToken()+"&search=&sortColumn=firstName&sortOrder=ASC",{})
        .then(result => {this.branchData = result.data.data[0];})
    }
  },
  mounted() {
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            this.tenantName = role[0].split("-")[0];
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            roleArray.includes("RiskManager") ? this.isBranchRiskManager = true : this.isBranchRiskManager = false;
            this.selectedOrgToken = authService.getOrgToken();
            this.getTraderList();
            this.getBranchData();
          }
        });
      }
};
</script>
<style scoped>
.listAcc{
  display: grid;
  grid-gap:5px;
}
.btn:not(.btn-success) {
  margin: 0;
  text-align: left;
}
.abs-btn-grp-arbs input{
  width: 150px;
}
</style>